/* eslint-disable @typescript-eslint/no-unused-vars */
import * as angular from 'angular';

angular.module('xplenty-designer', []);

window.xplenty = angular.module('xplenty', [
  'tandibar/ng-rollbar',
  'xplenty-designer',
  'ui.router',
  'permission',
  'permission.ui',
  'ui.sortable',
  'ui.grid',
  'ui.codemirror',
  'ngAnimate',
  'ngResource',
  'ngSanitize',
  'ngDragDrop',
  'angular-loading-bar',
  'pascalprecht.translate',
  'ngDialog',
  'angular.filter',
  'angular-md5',
  'angularUtils.directives.dirPagination',
  'ui.bootstrap',
  'ngTableResize',
]);
